import { SITE_SETTINGS_CONTEXT_TYPES } from '@/common/consts';

export default {
  AC: {
    Users: {
      url: '{accountConfigReadWrite}/api/account/{accountId}/configuration/le-users/users',
      params: {
        v: '5.0',
      },
    },
    SiteSettings: {
      url: '{accountConfigReadWrite}/api/account/{accountId}/configuration/setting/properties',
      params: {
        v: '3.0',
        context_type: SITE_SETTINGS_CONTEXT_TYPES.USER,
        context_cascading: false,
      },
    },
    // todo: change site settings url after it is deployed
    WorkatoSiteSettings: {
      url: '{accountConfigReadWrite}/api/account/{accountId}/configuration/setting/properties/voiceintegration.providers.config',
      params: {
        v: '3.0',
      },
    },
    Skills: {
      url: '{accountConfigReadWrite}/api/account/{accountId}/configuration/le-users/skills',
      params: {
        v: '2.0',
        select: '$all',
      },
    },
  },
  WORKATO: {
    WorkatoToken: {
      url: '{workatoPlatform}/api/v1/account/{accountId}/workato/user/token',
    },
    WorkatoRecipe: {
      url: '{workatoPlatform}/api/v1/account/{accountId}/workato/recipe',
    },
    WorkatoAdmins: {
      url: '{workatoPlatform}/api/v1/account/{accountId}/user',
    },
    ExistingWorkatoAccount: {
      url: '{workatoPlatform}/api/v1/account/{accountId}/workato',
    },
    ExistingWorkatoUser: {
      url: '{workatoPlatform}/api/v1/account/{accountId}/workato/user',
    },
    ImportWorkatoRecipe: {
      url: '{workatoPlatform}/api/v1/account/{accountId}/workato/recipe',
    },
    NewWorkatoAccount: {
      url: '{workatoPlatform}/api/v1/account/{accountId}/workato',
    },
    NewWorkatoUser: {
      url: '{workatoPlatform}/api/v1/account/{accountId}/workato/user',
    },
    IhubConfig: {
      url: '{ihubshellPlatform}/api/v1/account/{accountId}/config/{ihubConfig}',
    },
    WorkatoSettings: {
      url: '{ihubshellPlatform}/api/v1/account/{accountId}/user/{userId}/configs',
    },
    CreateWorkatoOnboardingPopupSetting: {
      url: '{ihubshellPlatform}/api/v1/account/{accountId}/user/{userId}/config',
    },
    UpdateWorkatoOnboardingPopupSetting: {
      url: '{ihubshellPlatform}/api/v1/account/{accountId}/user/{userId}/config/{configName}',
    },
  },
  MEDALLIA: {
    Initialization: {
      url: '{medalliaPlatform}/api/v1/account/{accountId}/setup/initialization',
    },
    AllSurveys: {
      url: '{medalliaPlatform}/api/v1/account/{accountId}/setup/surveys',
    },
    AllSkills: {
      url: '{medalliaPlatform}/api/v1/account/{accountId}/setup/skills',
    },
    TestAPIConfig: {
      url: '{medalliaPlatform}/api/v1/account/{accountId}/setup/medallia/connection',
    },
    MappingConfig: {
      url: '{medalliaPlatform}/api/v1/account/{accountId}/setup/mappings',
    },
    SaveConfigToDB: {
      url: '{medalliaPlatform}/api/v1/account/{accountId}/setup/medallia/config',
    },
    AccountInfo: {
      url: '{medalliaPlatform}/api/v1/account/{accountId}/config',
    },
  },
  SHELL: {
    iHubShell: {
      url: '{ihubshellPlatform}/api/v1/account/{AccountId}',
    },
  },
};
